import { Input as AntInput, InputProps } from 'antd';

import { BFC } from '@/shared/types';

export const Input: BFC<InputProps> = (props) => {
  return <AntInput {...props} />;
};
